import { TABLE_ACTION, TABLE_ACTION_STATE, ActionsColumn } from '@qrios/frontend-library';

import { UssdAppResponseItem, UssdAppTableRowActions, UssdAppTableData } from './interfaces';

export const mapApiDataIntoTableFormat = (
  data: UssdAppResponseItem[],
  actionsHandling: UssdAppTableRowActions
): UssdAppTableData[] =>
  data.map((ussdAppItem: UssdAppResponseItem) => {
    const { appId, appUrl, status, debugEnabled, authorizationMethod } = ussdAppItem;

    const actions = [
      {
        name: TABLE_ACTION.EDIT,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actionsHandling.edit({
            appId,
            appUrl,
            status,
            debugEnabled,
            authorizationMethod
          });
        }
      },
      {
        name: TABLE_ACTION.OPEN,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actionsHandling.openInEditor(appId);
        }
      }
    ];

    return {
      ...ussdAppItem,
      id: appId,
      actions: <ActionsColumn actions={actions} />
    };
  });
